export default __webpack_public_path__ + "static/media/30.539438e9.svg";